/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-display',
  templateUrl: './theme-option-tooltips-display.component.html',
  styleUrls: ['./theme-option-tooltips-display.component.css']
})
export class ThemeOptionTooltipsDisplayComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_enabled';

  constructor() {}

  receiveValue(value: boolean) {
    this.themeOptions.setOption('tooltips_enabled', value);
  }

}
